
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setErrorPopUp } from "@reducers/notification";
import { CUSTOM_MESSAGES } from "../../veriables";

const PrintMoveConfirmModal = ({ confirmPrint, setConfirmPrint, pendingActionType, actionTypes }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (confirmPrint) {
      let message = '';

      if (pendingActionType?.type === 'print') {
        message = CUSTOM_MESSAGES().SP_SELECT_SEAT_PRINT_ERROR;
      } else if (
        actionTypes?.type === 'sentMove' ||
        actionTypes?.type === 'unsentMove' ||
        pendingActionType?.type === 'sentMove' ||
        pendingActionType?.type === 'unsentMove'
      ) {
        message = CUSTOM_MESSAGES().SM_SELECT_SEAT_MOVE_ERROR;
      }

      if (message) {
        dispatch(setErrorPopUp({
          res: message,
          noErrorTxt: true,
        }));
        setConfirmPrint(false);
      }
    }
  }, [confirmPrint, setConfirmPrint, pendingActionType, actionTypes, dispatch]);

  return null;
};

export default PrintMoveConfirmModal;
